import scheduleDemo from "./schedule-demo";

export default { scheduleDemo };
